import React, { PropsWithChildren, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import Preloader from 'ui-lib/components/Preloader';
import ThemeProvider from 'ui-lib/ThemeProvider';
import { authSignOut, authValidate, initializePendoUser } from '../../actions/auth';
import { SharedDispatch } from '../../reducers/types';
import { useUnleashLoading } from '../../services/UnleashProvider/hooks/useUnleashLoading';
import { unleashClient } from '../../services/UnleashProvider/const';
import { getUserCompanies } from '../../actions/user-company';
import { fetchUserPreferences } from '../UserPreferences/actions';
import { getPortalLevelPermissions } from '../Permissions/api';

declare global {
  interface Window {
    isOhAppLoaded: boolean;
    isMapDisabled: boolean;
  }
}

/**
 * Sets isOhAppLoaded to window object. Needed for ATQC team to set token into local storage after app init
 * @returns {null}
 */
const AppInitializer = () => {
  useEffect(() => {
    window.isOhAppLoaded = true;
  }, []);
  return null;
};

const AppSplashScreen = ({ children, mixedTheme }: PropsWithChildren<{ mixedTheme: boolean }>) => {
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch<SharedDispatch>();
  const unleashLoading = useUnleashLoading();

  useEffect(() => {
    (async () => {
      try {
        await dispatch(getUserCompanies());
        await dispatch(authValidate());
        try {
          await getPortalLevelPermissions({ params: undefined });
        } catch (err) {
          dispatch(authSignOut());
          throw err;
        }
        await dispatch(fetchUserPreferences());
        dispatch(initializePendoUser());
      }
      catch (err) {
        //No actions needed, error is handled in nested actions.
      }
      finally {
        setLoading(false);
        unleashClient.start();
      }
    })();
  }, []);

  if (loading || unleashLoading) {

    if (mixedTheme) {
      return (
        <ThemeProvider>
          <Preloader />
        </ThemeProvider>
      );
    }

    return <Preloader />;
  }

  return (
    <>
      {children}
      <AppInitializer />
    </>
  );
};

export default AppSplashScreen;
